module.exports = __webpack_public_path__ + "img/box6-img-3.64d1099d.png";